import { render } from 'views/client';
import View from '.';

render(View);



// WEBPACK FOOTER //
// ./src/views/home/home.js